var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "directory",
    class: {
      'directory--is-loading': _vm.isLoading,
    }
  }, [_c('GuildSearch', _vm._b({
    staticClass: "directory__input",
    attrs: {
      "value": _vm.inputText
    },
    on: {
      "input": function($event) {
        _vm.$emit('text-input', $event)
      }
    }
  }, 'GuildSearch', {
    resultCount: _vm.resultCount,
    unitLabels: {
      singular: _vm.unitLabels.singular.toLowerCase(),
      plural: _vm.unitLabels.plural.toLowerCase(),
    }
  }, false)), _vm._v(" "), _c('Expand', {
    attrs: {
      "media": "(max-width: 959px)"
    }
  }, [_c('span', {
    slot: "header"
  }, [_vm._v("Filter " + _vm._s(_vm.unitLabels.plural))]), _vm._v(" "), _c('div', {
    staticClass: "directory__filters-list"
  }, [_vm._t("filters")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "directory__results-meta"
  }, [_c('span', {
    staticClass: "directory__result-count",
    class: {
      'directory__result-count--is-loading': _vm.isLoading
    }
  }, [_vm._v(_vm._s(_vm.resultCountLabel))]), _vm._v(" "), (_vm.activeFilters.length) ? _c('button', {
    staticClass: "directory__clear-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('clear-all')
      }
    }
  }, [_vm._v("Clear all")]) : _vm._e(), _vm._v(" "), (_vm.activeFilters.length) ? _c('div', {
    staticClass: "directory__filter-tags"
  }, _vm._l((_vm.activeFilters), function(filter) {
    return _c('CmTag', {
      key: filter.keys[0],
      staticClass: "directory__filter-tag",
      attrs: {
        "label": filter.label,
        "value": filter.label
      },
      on: {
        "delete": function($event) {
          _vm.$emit("clear-filter", filter.keys, filter.match)
        }
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "directory__list",
    class: {
      'directory__list--is-loading': _vm.isLoading,
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.results.length < _vm.resultCount) ? _c('button', {
    staticClass: "directory__load-button cm-button wide",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('more-click')
      }
    }
  }, [_vm._v("More")]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4330e785","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/directory.vue
// module id = null
// module chunks = 